import { DownloadAppRow, useStoreCountContext, DownloadPluginButton } from '@mybonus/ui';

import { Wrapper, Image, Content, $CmsContent } from './PlatformSection.parts';

export type PlatformSectionProps = {
	platform: 'APP' | 'EXT' | 'WEB';
};

const platforms = {
	APP: {
		code: 'home_app_intro',
		download: <DownloadAppRow />,
		image: '/assets/images/app-mockup.webp',
	},
	EXT: {
		code: 'home_plugin_intro',
		download: <DownloadPluginButton vendor="chrome" />,
		image: '/assets/images/plugin-macbook.png',
	},
	WEB: {
		code: 'home_web_intro',
		download: null,
		image: '/assets/images/plugin-macbook.png',
	},
};

export function PlatformSection(props: PlatformSectionProps) {
	const storeCount = useStoreCountContext();
	const platform = platforms[props.platform];

	return (
		<Wrapper>
			<Content>
				<$CmsContent code={platform.code} replacements={{ storeCount: storeCount.text }} />
				{platform.download}
			</Content>
			<Image uri={platform.image} />
		</Wrapper>
	);
}
